import * as React from "react"

export default function RideIcon(props) {
  return (
    <svg
      width={33}
      height={32}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.5 3H17.5V5.10938C24.173 5.61985 29.4287 11.1963 29.4287 18C29.4287 25.1402 23.6402 30.9287 16.5 30.9287C12.6384 30.9287 9.17132 29.2342 6.80371 26.5518L8.19629 25.3232C10.2263 27.6231 13.1935 29.0713 16.5 29.0713C22.6146 29.0713 27.5713 24.1146 27.5713 18C27.5713 11.8854 22.6146 6.92871 16.5 6.92871C13.1935 6.92871 10.2263 8.37685 8.19629 10.6768L6.80371 9.44824C8.96502 6.99951 12.0426 5.37405 15.5 5.10938V3H12.5V1H20.5V3ZM20.9648 10.2666C23.6311 11.809 25.4287 14.694 25.4287 18C25.4287 22.931 21.4311 26.9287 16.5 26.9287H15.5713V23H17.4287V25.0088C20.8951 24.5539 23.5713 21.5905 23.5713 18C23.5713 15.7172 22.4899 13.6864 20.8086 12.3926L18.6914 16.0605C19.5036 16.978 19.6825 18.3453 19.0361 19.4648C18.2273 20.8652 16.4367 21.3446 15.0361 20.5361C13.6355 19.7275 13.1554 17.9368 13.9639 16.5361C14.61 15.417 15.8827 14.8878 17.083 15.1318L20.1602 9.80078L20.9648 10.2666ZM9.5 23H4.5V21H9.5V23ZM17.0361 17.0723C16.5237 16.7764 15.8681 16.9524 15.5723 17.4648C15.2767 17.9773 15.4525 18.6319 15.9648 18.9277C16.4771 19.2233 17.1318 19.0482 17.4277 18.5361C17.7235 18.0238 17.5484 17.3682 17.0361 17.0723ZM8.5 19H1.5V17H8.5V19ZM9.5 15H4.5V13H9.5V15Z"
        fill={props.fill}
      />
    </svg>
  )
}